import { forwardRef } from 'react'
import type { SelectHTMLAttributes } from 'react'
import classNames from 'classnames'
import styles from './style.module.css'

export interface SelectOption {
  value: string
  label: string
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: SelectOption[]
  invalid?: boolean
  isLoading?: boolean
  placeholder?: string
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
  (
    { className, invalid = false, isLoading = false, options = [], placeholder, ...rest },
    ref,
  ) => (
    <select
      ref={ref}
      className={classNames(styles.select, className, { [styles.invalid]: invalid })}
      aria-invalid={invalid}
      disabled={isLoading || rest.disabled}
      {...rest}
    >
      <option value="">{isLoading ? 'Buscando' : (placeholder ?? 'Selecione')}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  ),
)

Select.displayName = 'Select'

export default Select
